import { createTheme } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

type TThemeProps = {
  primaryColorFromBO?: string;
  secondaryColorFromBO?: string;
  tertiaryColorFromBO?: string;
  mainColorFromBO?: string;
};

const theme = ({
  primaryColorFromBO,
  secondaryColorFromBO,
  tertiaryColorFromBO,
  mainColorFromBO,
}: TThemeProps) =>
  createTheme({
    colors: {
      paletteFromBO: {
        main: mainColorFromBO || '#651c32',
        primary: primaryColorFromBO || '#f2b308',
        secondary: secondaryColorFromBO || '#f2b308',
        tertiary: tertiaryColorFromBO || '#54667a',
      },
      grey: {
        main: '#54667a',
        dark: '#4e4e4e',
        light: '#aab7c5',
        light1: '#99a3ad',
        light2: '#a5a5a5',
        light3: '#e0e0e0',
        light4: '#dbddde',
        light5: '#f0f3f5',
        light6: '#fcefcd',
      },
      success: {
        main: '#78ba8a',
      },
      error: {
        main: '#e67575',
      },
      white: '#ffffff',
      black: {
        main: '#000000',
        dark1: 'rgba(101, 28, 50, 0.23)',
        dark2: 'rgba(242, 179, 8, .06)',
        dark3: 'rgba(101, 28, 50, 0.13)',
      },
      burgundyRed: {
        main: '#651c32',
        red1: 'rgba(101, 28, 50, 0.82)',
        red2: '#7c3d50',
      },
      orange: {
        light: '#ffcf4e',
        main: '#f2b308',
        dark: '#cc7b34',
      },
    },
    fontSizes: {
      mobileBasicText: 14,
      desktopBasicText: 16,
      mobileCTA: 14,
      desktopCTA: 16,
      mobileMenu: 14,
      desktopMenu: 16,
      mobileSubmenu: 14,
      desktopSubmenu: 16,
      mobileLabel: 14,
      desktopLabel: 16,
      mobileTitle: 24,
      desktopTitle: 30,
      mobileSubtitle: 18,
      desktopSubtitle: 20,
      footerLinks: 14,
    },
    typography: {
      fontFamily: '"RaleWay", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 20,
      },
      body2: {
        fontSize: 16,
      },
      caption: {
        fontSize: 14,
      },
      button: {
        fontSize: 17,
      },
      h5: {
        fontSize: 14,
      },
    },
    boxShadow:
      '0px 3px 3px -2px rgba(170, 183, 197, 0.35), 0px 3px 4px 0px rgba(170, 183, 197, 0.35), 0px 1px 8px 0px rgba(170, 183, 197, 0.35);',
    layout: {
      widgets: {
        widgetHeight: 579,
        actionBannerHeight: 130,
        actionBannerHeightMobile: 90,
        actionContentHeight: 410,
        actionImageHeight: 220,
      },
    },
    radius: 5,
    palette: {
      primary: {
        main: mainColorFromBO || '#651c32',
        light: primaryColorFromBO || '#f2b308',
        dark: tertiaryColorFromBO || '#54667a',
      },
      secondary: {
        main: secondaryColorFromBO || '#f2b308',
      },
    },
  } as ICustomTheme);

export default theme;
